<template>
  <el-card v-loading='loading' class='profile-permissions-card'>
    <!--    <div slot="header" class="clearfix">-->
    <!--      <b class="font-16">我的权限 &nbsp;</b>-->
    <!--    </div>-->
    <el-tabs v-model='activeTab' class='text-center' @tab-click='handleTabClick'>
      <el-tab-pane label='基本权限' name='userinfo'>
        <div class='permissionsBox'>
          <b>当前角色：</b>
          <span style='font-size: 0.9em'>{{ userInfo.role_name || '' }} </span>
          <br />
          <b>所属部门：</b>
          <span style='font-size: 0.9em'>
            <span v-for='(dept, key) in userInfo.depts' :key='dept.dpt_id'>
              <el-tooltip :content='`${dept.name}(${dept.dpt_id})`' placement='bottom' effect='light'>
                <span style='margin-right: 5px'>{{ dept.name || '' }}
                  {{ key != userInfo.depts.length - 1 ? '/' : '' }}</span>
              </el-tooltip>
            </span>
          </span>
          <br />
          <b>直属主管：</b>
          <span v-for='leader in leaders' :key='`${leader.id}+${leader.dept_id}`'
                style='margin-right: 5px;font-size: 0.9em'>
            {{ leader.name || '' }}
            <!--              <span v-if="leader.is_leave == 'Y'" style='color: red'>（已离职）</span>-->
          </span>
        </div>
      </el-tab-pane>
      <el-tab-pane label='权限申请' name='application'>
        <RoleApplyPanel/>
      </el-tab-pane>
      <el-tab-pane label='申请记录' name='applicationHistory'>
        <div class='default-table'>
          <el-table :data='historyList' height='220'>
            <el-table-column align='left' label='申请内容' show-overflow-tooltip min-width='220' prop='rej_reason'>
              <template slot-scope='{row}'>
                <div>{{ row.apply_user_id === userInfo.id ? '你' : row.apply_user_name }}
                  于{{ $utils.parseTime(row.created_at, '{y}-{m}-{d} {h}:{i}') }}
                  向 {{ row.rec_user_name }}
                  申请『{{ row.role_names || '' }}』角色
                </div>
                <div class='sub'>
                  <span style='font-size: 0.9em;color: #F56C6C' v-if='row.rej_reason'>拒绝原因：{{ row.rej_reason || ''
                  }}</span>
                  <span style='font-size: 0.9em;color: #409EFF' v-if='row.remark'> 备注：{{ row.remark || '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <!--            <el-table-column align='center' label='序号' type='index' width='60'></el-table-column>-->
            <!--            <el-table-column align='center' label='接收人' prop="rec_user_name" min-width='100'></el-table-column>-->
            <!--            <el-table-column align='center' label='角色' show-overflow-tooltip min-width='120' prop="role_names"></el-table-column>-->
            <!--            <el-table-column align='center' label='状态' prop="_status"  min-width='60'></el-table-column>-->
            <!--            <el-table-column align='center' label='拒绝原因/备注' show-overflow-tooltip  min-width='120' prop="rej_reason">-->
            <!--              <template slot-scope='{row}'>-->
            <!--                <span>{{row.rej_reason}}</span>-->
            <!--                <span>{{row.remark}}</span>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column align='center' label='备注' show-overflow-tooltip prop="remark"></el-table-column>-->
            <el-table-column
              width='140'
              fixed='right'
              label='操作' align='center'>
              <template slot-scope='{row}'>
                <el-link v-if='row.status===1' icon='el-icon-refresh-left' :disabled='loadingCommit'
                         @click='handleRevoke(row)' type='danger'>撤销
                </el-link>
                &nbsp;
                <el-link v-if='row.status===1' icon='el-icon-chat-line-square' :disabled='loadingCommit'
                         @click='handleNotify(row)'
                         type='warning'>通知
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <Pagination :limit.sync='pagingData.page_size'
                      :page.sync='pagingData.current_page'
                      :total='pagingData.total'
                      small
                      layout='prev, pager, next'
                      @pagination='getHistory' />
        </div>
      </el-tab-pane>
      <el-tab-pane label='审批记录' name='forYouApply'>
        <div class='default-table'>
          <el-table :data='applyList' height='220'>
            <el-table-column align='left' label='申请内容' show-overflow-tooltip min-width='220' prop='rej_reason'>
              <template slot-scope='{row}'>
                <div>{{ row.apply_user_name }}
                  于{{ $utils.parseTime(row.created_at, '{y}-{m}-{d} {h}:{i}') }}
                  向 {{ row.rec_user_id === userInfo.id ? '你' : row.rec_user_name }}
                  申请『{{ row.role_names || '' }}』角色
                </div>
                <div class='sub'>
                  <span style='font-size: 0.9em;color: #F56C6C' v-if='row.rej_reason'>拒绝原因：{{ row.rej_reason || ''
                  }}</span>
                  <span style='font-size: 0.9em;color: #409EFF' v-if='row.remark'> 备注：{{ row.remark || '-' }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width='140'
              fixed='right'
              label='操作' align='center'>
              <template slot-scope='{row}'>
                <el-link v-if='row.status===1' icon='el-icon-circle-check' :disabled='loadingCommit'
                         @click='handlePass(row)' type='primary'>同意
                </el-link>
                &nbsp;
                <el-link v-if='row.status===1' icon='el-icon-circle-close' :disabled='loadingCommit'
                         @click='handleRej(row)'
                         type='warning'>拒绝
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <Pagination :limit.sync='pagingData.page_size'
                      :page.sync='pagingData.current_page'
                      :total='pagingData.total'
                      small
                      layout='prev, pager, next'
                      @pagination='getFoYouApply' />
        </div>
      </el-tab-pane>
    </el-tabs>


  </el-card>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import { mapGetters } from 'vuex'
import RoleApplyPanel from '@/pages/user/components/RoleApplyPanel.vue'

export default {
  name: 'UserComponentsUserPermissions',
  components: { PageHeaderLayout, RoleApplyPanel },
  computed: {
    ...mapGetters(['userPermissions', 'roles', 'userInfo'])
  },
  data() {
    return {
      loading: false,
      loadingCommit: false,
      //我的上级可申请的角色
      defaultProps: {
        id: 'id',
        children: 'children',
        label: 'display_name'
      },
      leaders: [], //我的上级领导
      activeTab: 'userinfo',
      historyList: [],
      pagingData: {
        page_size: 5,
        current_page: 1,
        total: 0
      },
      applyList: []//向我申请的审批记录
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleTabClick(tab, event) {
      // console.log(tab, event)
      // console.log('event.type', event.type);
      switch (this.activeTab) {
        case 'applicationHistory':
          this.getHistory()
          break
        case 'forYouApply':
          this.getFoYouApply()
          break
      }
    },
    // 获取可申请角色列表
    async getList() {
      this.loading = true
      const { leaders } = await this.$api.getMyApplyRoleList()
      this.leaders = leaders
      setTimeout(() => {
        this.loading = false
      }, 50)
    },
    async getHistory() {
      const searchCondition = {}
      Object.assign(searchCondition, {
        page_size: this.pagingData.page_size || 10,
        current_page: this.pagingData.current_page || 1
      }, { apply_user_id: this.userInfo.id })

      const { list, pages } = await this.$api.getMyRoleApplyRecords(searchCondition)
      this.historyList = list || []
      this.pagingData.page_size = pages.page_size || 5
      this.pagingData.current_page = pages.current_page || 1
    },
    handleRevoke(row) {

      this.$confirm(`确定要撤销『角色：${row.role_names}』的申请吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.postRevokeApply(row.id)
        await this.getHistory()
      }).catch(() => {
        this.$notify.info('取消操作')
      })
    },
    handleNotify(row) {
      this.$confirm(`确定要再次通知审批『角色：${row.role_names}』的申请吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.notifyLeaderApply(row.id)
        await this.getHistory()

      }).catch(() => {
        this.$notify.info('取消操作')
      })
    },
    async getFoYouApply() {
      const searchCondition = {}
      Object.assign(searchCondition, {
        page_size: this.pagingData.page_size || 5,
        current_page: this.pagingData.current_page || 1
      }, { rec_user_id: this.userInfo.id })

      const { list, pages } = await this.$api.getMyRoleApplyRecords(searchCondition)
      this.applyList = list || []
      this.pagingData.page_size = pages.page_size || 5
      this.pagingData.current_page = pages.current_page || 1
    },
    async handleRej(row) {
      //拒绝申请
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      }).then(async ({ value }) => {
        this.loadingCommit = true
        await this.$api.handleRejRoleApply({ id: row.id, rej_reason: value })
        await this.getFoYouApply()
        this.loadingCommit = false
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消操作'
        })
      })
    },
    async handlePass(row) {
      //同意申请
      this.loadingCommit = true
      await this.$api.handlePassRoleApply({ id: row.id })
      await this.getFoYouApply()
      this.loadingCommit = false

    }

  },
  mounted() {
    this.getList()
    this.getHistory()
  }
}
</script>

<style lang='scss' scoped>
::v-deep .el-tabs__header {
  margin: 0 0 14px;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #edf1f6;
}

::v-deep .el-tabs__item {
  height: 38px;
  color: #667085;
  font-size: 13px;
  line-height: 38px;
}

::v-deep .el-tabs__item.is-active {
  color: #ff3176;
  font-weight: 600;
}

::v-deep .el-tabs__active-bar {
  background-color: #ff3176;
}

.profile-permissions-card {
  min-height: 420px;
  border: 0;
  box-shadow: none;
  text-align: left;
}

.profile-permissions-card ::v-deep .el-card__body {
  padding: 0;
}

.permissionsBox {
  min-height: 220px;
  padding: 18px 20px;
  background: #fbfcfe;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
  text-align: left;

  > b {
    display: inline-block;
    min-width: 88px;
    color: #344054;
    font-size: 13px;
    font-weight: 600;
    margin: 8px 0;
  }

  > span {
    color: #1f2937;
    font-size: 13px;
    line-height: 22px;
  }
}

.default-table {
  border: 1px solid #edf1f6;
  border-radius: 8px;
  overflow: hidden;
}

.default-table ::v-deep .el-table th {
  background: #f8fafc;
  color: #475467;
  font-weight: 600;
}

.default-table ::v-deep .el-table td,
.default-table ::v-deep .el-table th {
  border-bottom-color: #edf1f6;
}

.default-table ::v-deep .el-pagination {
  padding: 10px 12px;
  background: #ffffff;
  text-align: right;
}

.rej_reason {
  color: red;
  font-size: 0.9em;
}
</style>
